import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlayCircle, PawPrint } from "lucide-react";
import api from "@/lib/api";

export const PetStoriesStrip = () => {
  const [stories, setStories] = useState([]);
  useEffect(() => {
    api.get("/videos", { params: { tag: "pet stories" } }).then((r) => setStories(r.data.slice(0, 6))).catch(() => {});
  }, []);
  if (stories.length === 0) return null;
  return (
    <section data-testid="pet-stories-strip" className="rounded-3xl bg-sage-light p-8 lg:p-10">
      <h2 className="flex items-center gap-2 text-2xl sm:text-3xl font-normal text-charcoal-800">
        <PawPrint size={22} className="text-terracotta" /> Real pets, really here
      </h2>
      <p className="mt-2 max-w-2xl text-charcoal-600">
        Clips shared by our own clients of their pets arriving and settling into Mérida — no scripts, just wagging tails.
      </p>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stories.map((v) => (
          <Link key={v.id} to={`/life-in-mexico/${v.slug}`} data-testid={`pet-story-card-${v.slug}`}
            className="group overflow-hidden rounded-2xl border border-sand-200 bg-white hover:border-terracotta transition-colors">
            <div className="relative aspect-video overflow-hidden bg-charcoal-800">
              {v.thumbnail && <img src={v.thumbnail} alt={v.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />}
              <span className="absolute inset-0 flex items-center justify-center">
                <PlayCircle size={40} className="text-white drop-shadow-lg opacity-90" strokeWidth={1.2} />
              </span>
            </div>
            <div className="p-4">
              <p className="text-sm font-medium text-charcoal-800 group-hover:text-terracotta transition-colors">{v.title}</p>
              {v.description && <p className="mt-1 text-xs text-charcoal-500 line-clamp-2">{v.description}</p>}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
